const StarRating = ({ rating }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "3.5rem", // bigger stars
        color: "#f5c518",
        fontWeight: "bold",
        lineHeight: 1,
        border: "1px solid #ddd",
        padding: "12px 16px",
        borderRadius: "13px",
        width: "fit-content",
        margin: "12px", // centers horizontally
      }}
    >
      {[...Array(5)].map((_, index) => (
        <span key={index} style={{ margin: "0 4px" }}>
          {index < rating ? "★" : "☆"}
        </span>
      ))}
    </div>
  );
};

export default StarRating;
